var api = require("!../../node_modules/_style-loader@1.2.1@style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../node_modules/_css-loader@3.5.3@css-loader/dist/cjs.js??ref--5-1!../../node_modules/_less-loader@6.1.0@less-loader/dist/cjs.js??ref--5-2!./index.less");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};